import styled from "styled-components";

import { OptionTiles } from "../../../../../../components/OptionTiles";
import { StickyBarPage } from "../../../../../../components/SaveBar";

/* Field types as a grid of tiles (the tiles every choice of the editor uses) */
export const TypeGrid = OptionTiles;

export const Hint = styled.p`
  margin-top: -0.5rem;

  /* Under a grid of tiles (not a field), where the negative margin would glue it to the tiles */
  &.below-grid {
    margin-top: 0;
  }

  font-size: 0.75rem;
  line-height: 1rem;
  color: var(--color-neutral-150);
`;

export const ToggleRow = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
  padding-top: 1rem;
  border-top: 1px solid var(--color-neutral-base);

  .text {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    min-width: 0;
  }

  .description {
    font-size: 0.75rem;
    line-height: 1rem;
    color: var(--color-neutral-150);
  }

  /* The toggle's label is sized by its absolutely positioned track: give it the track's box */
  > label {
    flex-shrink: 0;
    width: 40px;
    height: 24px;
    padding: 0;
    margin: 0;

    input:not(:checked) ~ span {
      background-color: var(--color-neutral-base);
    }
  }
`;

/* Keeps the sticky save bar at the bottom even though this screen is short */
export const Page = styled(StickyBarPage)``;

/* A setting under the field name, split from it by a divider (like the required toggle) */
export const Divided = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-top: 1rem;
  border-top: 1px solid var(--color-neutral-base);
`;

export const Warning = styled.p`
  margin-top: 0.5rem;
  font-size: 0.75rem;
  line-height: 1rem;
  color: var(--color-orange);
`;
